import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ContactSettings.css';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const emptyContact = {
  heroTitle: '',
  heroImage: '',
  formHeading: '',
  location: '',
  email: '',
  phone: '',
};

function ContactSettings() {
  const [contact, setContact] = useState(emptyContact);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/contact`);
        const data = response.data || {};
        setContact({
          heroTitle: data.heroTitle ?? '',
          heroImage: data.heroImage ?? '',
          formHeading: data.formHeading ?? '',
          location: data.location ?? '',
          email: data.email ?? '',
          phone: data.phone ?? '',
        });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchContact();
  }, []);

  const handleChange = (field, value) => {
    setContact((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    setIsSaving(true);
    setMessage('');

    try {
      await axios.put(`${API_BASE_URL}/api/contact`, contact);
      setMessage('Contact page updated successfully.');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      setMessage('Unable to save. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) {
    return <p className="contact-settings-loading">Loading contact page…</p>;
  }

  return (
    <div className="contact-settings">
      <div className="contact-settings-header">
        <div>
          <h2 className="contact-settings-title">Contact page</h2>
          <p className="contact-settings-subtitle">
            Edit hero, form heading, and sidebar contact info (location, email, phone).
          </p>
        </div>
        <button
          type="button"
          className="contact-settings-save-btn"
          onClick={handleSave}
          disabled={isSaving}
        >
          {isSaving ? 'Saving…' : 'Save changes'}
        </button>
      </div>

      <div className="contact-settings-grid">
        <div className="contact-settings-field contact-settings-field-wide">
          <h3 className="contact-settings-section-title">Hero</h3>
          <label className="contact-settings-label">
            Hero title
            <input
              type="text"
              className="contact-settings-input"
              value={contact.heroTitle}
              onChange={(e) => handleChange('heroTitle', e.target.value)}
              placeholder="Contact Us"
            />
          </label>
          <label className="contact-settings-label">
            Hero image URL
            <input
              type="text"
              className="contact-settings-input"
              value={contact.heroImage}
              onChange={(e) => handleChange('heroImage', e.target.value)}
              placeholder="https://... or leave empty to use default"
            />
          </label>
        </div>

        <div className="contact-settings-field contact-settings-field-wide">
          <h3 className="contact-settings-section-title">Form</h3>
          <label className="contact-settings-label">
            Form heading
            <input
              type="text"
              className="contact-settings-input"
              value={contact.formHeading}
              onChange={(e) => handleChange('formHeading', e.target.value)}
              placeholder="Leave us your info"
            />
          </label>
        </div>

        <div className="contact-settings-field contact-settings-field-wide">
          <h3 className="contact-settings-section-title">Sidebar contact</h3>
          <label className="contact-settings-label">
            Location
            <input
              type="text"
              className="contact-settings-input"
              value={contact.location}
              onChange={(e) => handleChange('location', e.target.value)}
              placeholder="Sheikh Zaid, Giza, Egypt"
            />
          </label>
          <label className="contact-settings-label">
            Email
            <input
              type="email"
              className="contact-settings-input"
              value={contact.email}
              onChange={(e) => handleChange('email', e.target.value)}
              placeholder="Info@WhalesAdvisory.com"
            />
          </label>
          <label className="contact-settings-label">
            Phone
            <input
              type="text"
              className="contact-settings-input"
              value={contact.phone}
              onChange={(e) => handleChange('phone', e.target.value)}
              placeholder="01000355950"
            />
          </label>
        </div>
      </div>

      {message && (
        <p className="contact-settings-message">{message}</p>
      )}
    </div>
  );
}

export default ContactSettings;
